function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Master",
  stroke: "none",
  strokeWidth: 1.5,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Withdraw-Funds---check---review-",
  transform: "translate(-788.000000, -293.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(773.000000, 81.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(15.000000, 104.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Modal/Deposit-status-2",
  transform: "translate(0.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(0.000000, 16.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  fill: "#F0F5F6",
  cx: 20,
  cy: 20,
  r: 20
}), /*#__PURE__*/React.createElement("g", {
  id: "Credit-card",
  transform: "translate(12.000000, 8.000000)",
  fill: "#C9D6DB",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8,0.5 C3.5835,0.5 0,3.66790179 0,7.57142857 C0,13.8571429 8,22.5 8,22.5 C8,22.5 16,13.8571429 16,7.57142857 C16,3.66790179 12.4165,0.5 8,0.5 Z M8,11.5 C6.2326888,11.5 4.8,10.0928949 4.8,8.35714286 C4.8,6.62139079 6.2326888,5.21428571 8,5.21428571 C9.7673112,5.21428571 11.2,6.62139079 11.2,8.35714286 C11.198071,10.0921096 9.76651158,11.4981055 8,11.5 Z",
  id: "Shape"
}))))))));

var SvgLocationRound = function SvgLocationRound(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocationRound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/location-round.82886bd4.svg";
export { ForwardRef as ReactComponent };